import { createContext, useContext, useEffect, useState } from "react";
import de from "./de";
import tr from "./tr";
import en from "./en";

const dictionaries = { de, tr, en };
const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState("de");
  const t = dictionaries[lang] || de;

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
